import { FLIRTING_STYLE_OPTIONS } from '@/pages/Onboarding/options/FlirtingStyle/FLIRTING_STYLE_OPTIONS';
import { FlirtingStyleOptionIdType } from '@/pages/Onboarding/options/FlirtingStyle/types';
import { HisTypeOptionIdType } from '@/pages/Onboarding/options/HisType/types';
import { HisVoiceOptionIdType } from '@/pages/Onboarding/options/HisVoice/types';
import { HOBBIES_INTERESTS_OPTIONS } from '@/pages/Onboarding/options/HobbiesInterests/HOBBIES_INTERESTS_OPTIONS';
import { HobbiesInterestsOptionIdType } from '@/pages/Onboarding/options/HobbiesInterests/types';

export type Selections = {
  his_type: HisTypeOptionIdType | null;
  his_voice: HisVoiceOptionIdType | null;
  flirting_style: FlirtingStyleOptionIdType | null;
  hobbies_interests: HobbiesInterestsOptionIdType | null;
};

export type Tag = {
  icon: string; // ionicons name
  label: string;
};

const hisTypeIcon = 'person';
const hisVoiceIcon = 'mic';
const flirtingStyleIcon = 'heart';
const hobbiesIcons: Record<HobbiesInterestsOptionIdType, string> = {
  fitness_gym: 'barbell',
  art_culture: 'color-palette',
  music_festivals: 'musical-notes',
  gaming_tech: 'game-controller',
  cooking_foodie: 'restaurant',
  travel_adventure: 'boat',
};

export function getTagsBySelection(selections: Selections): Tag[] {
  const tags: Tag[] = [];

  // his_type
  if (selections.his_type) {
    tags.push({
      icon: hisTypeIcon,
      label: getTitleById(selections.his_type, 'his_type'),
    });
  }

  // his_voice
  if (selections.his_voice) {
    tags.push({
      icon: hisVoiceIcon,
      label: getTitleById(selections.his_voice, 'his_voice'),
    });
  }

  // flirting_style
  if (selections.flirting_style) {
    tags.push({
      icon: flirtingStyleIcon,
      label: getTitleById(selections.flirting_style, 'flirting_style'),
    });
  }

  // hobbies_interests
  if (selections.hobbies_interests) {
    tags.push({
      icon: hobbiesIcons[selections.hobbies_interests] || 'barbell',
      label: getTitleById(selections.hobbies_interests, 'hobbies_interests'),
    });
  }

  return tags;
}

function getTitleById(
  id: string,
  type: 'his_type' | 'his_voice' | 'flirting_style' | 'hobbies_interests',
): string {
  switch (type) {
    case 'his_type':
      return (
        {
          twink: 'Twink',
          daddy: 'Daddy',
          trans: 'Trans',
          otter: 'Otter',
          queer: 'Queer',
          leather: 'Leather',
          boy: 'Boy',
          pup: 'Pup',
          clean_cut: 'Clean-cut',
          jock_sporty: 'Jock/Sporty',
          bear: 'Bear',
          geek: 'Geek',
        }[id] || id
      );
    case 'his_voice':
      return (
        {
          deep_slow: 'Deep & Slow voice',
          warm_soft: 'Warm & soft voice',
          doesnt_matter: "Doesn't matter",
        }[id] || id
      );
    case 'flirting_style':
      return FLIRTING_STYLE_OPTIONS.find((opt) => opt.id === id)?.title || id;
    case 'hobbies_interests':
      return (
        HOBBIES_INTERESTS_OPTIONS.find((opt) => opt.id === id)?.title || id
      );
    default:
      return id;
  }
}
